import axios, { getEnv } from './api';
import Axios from "axios";

// FILTERS
function filterRoutes(fill) {
    let url = '';
    // DATA INICIAL
    if (fill?.dataFinal && !fill?.dataInicial) {
        url = `?dataFim=${fill?.dataFinal}`;
        return url;
    }
    // DATA FINAL E INICIAL
    else if (
        fill?.dataFinal &&
        fill?.dataInicial &&
        !fill?.cidades &&
        !fill?.ufs
    ) {
        url = `?dataInicio=${fill?.dataInicial}&dataFim=${fill?.dataFinal}`;
        return url;
    }
    // TODOS
    else if (fill?.dataFinal && fill?.dataInicial && fill?.ufs && fill?.cidades) {
        url = `?cidade=${fill?.cidades?.map((c) => c.id)}&dataFim=${
            fill?.dataFinal
        }&dataInicio=${fill?.dataInicial}&uf=${fill?.ufs?.map((uf) => uf.id)}`;
        return url;
    }
    // DATA FINAL/INICIAL E UF
    else if (fill?.dataFinal && fill?.dataInicial && fill?.ufs) {
        url = `?dataFim=${fill?.dataFinal}&dataInicio=${
            fill?.dataInicial
        }&uf=${fill?.ufs?.map((uf) => uf.id)}`;
        return url;
    }

    // UF E CIDADE
    else if (
        !fill?.dataFinal &&
        !fill?.dataInicial &&
        fill?.ufs &&
        fill?.cidades
    ) {
        url = `?cidade=${fill?.cidades?.map((c) => c.id)}&uf=${fill?.ufs?.map(
            (uf) => uf.id
        )}`;
        return url;
    }
    // CIDADE
    else if (
        !fill?.dataFinal &&
        !fill?.dataInicial &&
        !fill?.ufs &&
        fill?.cidades
    ) {
        url = `?cidade=${fill?.cidades?.map((c) => c.id)}`;
        return url;
    }
    // UF
    else if (
        !fill?.dataFinal &&
        !fill?.dataInicial &&
        !fill?.cidades &&
        fill?.ufs
    ) {
        url = `?uf=${fill?.ufs?.map((uf) => uf.id)}`;
        return url;
    }
    return url;
}

function filterRoutesToday(fill) {
    let url = '';

    // CIDADE
    if (!fill?.ufs && fill?.cidades) {
        url = `?cidade=${fill?.cidades?.map((c) => c.id)}`;
        return url;
    }
    // UF
    else if (!fill?.cidades && fill?.ufs) {
        url = `?uf=${fill?.ufs?.map((uf) => uf.id)}`;
        return url;
    }

    // TODOS
    else if (fill?.ufs && fill?.cidades) {
        url = `?uf=${fill?.ufs?.map((uf) => uf.id)}&cidade=${fill?.cidades?.map(
            (c) => c.id
        )}`;
    }
    return url;
}

const dashboardServiceSse = {
    getUsuariosApp: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/usuarios-app${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },

    getUf: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/uf${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },

    getTotal: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/total${filterRoutes(filters)}`,
                {signal: controller}
            );
            console.log('res', res);
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },

    getStatusEnvio: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/status-envio${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getPorte: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/porte${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getPorteMei: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/porte-mei${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getPorteMe: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/porte-me${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getPorteEpp: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/porte-epp${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getPorcemUsuariosApp: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/porcentagem-usuarios-app${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getPorcemStatusEnvio: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/porcentagem-status-envio${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getHora: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/hora${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },

    getHoje: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/hoje${filterRoutesToday(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getDia: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/dia${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getCidade: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/cidade${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },

    getAtendente: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/atendente${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getRecorrenciaPj: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/recorrencia${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getSemAnotacao: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/sem-anotacao${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getSemPlanoAcao: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/sem-plano-acao${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getSemFoto: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/sem-foto${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getSemArquivo: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/dashboard/sem-arquivo${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
};

export default dashboardServiceSse;
